import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class ContentRoutes extends RouteBase {
  prefix = 'panel.api.components.'

  convertDocxToHtml() {
    return this.ziggyRoute('docx_to_html')
  }
}
